/** Minutes in a 24-hour day. */
export const MINUTES_PER_DAY = 1440;
